import { useMemo } from "react";
import { Wrapper } from "../styles";
import { Image } from "../styles/Design";

const staticsBacked = require("../../assets/images/statitics.jpg");

const Statistics = () => {
  const listOfStatistics = useMemo(
    () => [
      {
        title: "Translators",
        statistic: "+ 25,252",
        icon: require("../../assets/icons/translators.svg").default,
      },
      {
        title: "Subscribers",
        statistic: "+ 25,252",
        icon: require("../../assets/icons/online-classs.svg").default,
      },
      {
        title: "Services",
        statistic: "+ 25,252",
        icon: require("../../assets/icons/monitor.svg").default,
      },
      {
        title: "Jobs",
        statistic: "+ 25,252",
        icon: require("../../assets/icons/searching.svg").default,
      },
    ],
    []
  );
  return (
    <Wrapper type="container" id="statistics" background={staticsBacked}>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-around' }}>
        {listOfStatistics.map((data, index) => (
          <div
            style={{
              display: "flex",
              background: "rgba(255, 255, 255, 0.19)",
              width: "278px",
              height: "113px",
              color: "rgba(241, 241, 241, 1))",
              border: "1px solid rgba(229, 229, 229, 1)",
              borderRadius: "25px",
              alignItems: "center",
              justifyContent: "space-around",
              margin: '2rem 0',
            }}
          >
            <div style={{ width: "54px", height: "54px" }}>
              <Image src={data.icon} alt={data.title} />
            </div>
            <div>
              <h3
                style={{
                  color: "rgba(244, 152, 35, 1)",
                  fontSize: "24px ",
                  lineHeight: "29px",
                  fontWeight: "bold",
                }}
              >
                {data.statistic}
              </h3>
              <h3
                style={{
                  color: "#F1F1F1",
                  fontSize: "18px ",
                  lineHeight: "22px",
                  fontWeight: "500",
                }}
              >
                {data.title}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </Wrapper>
  );
};

export default Statistics;
